import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import lodashGet from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import FooterButtons from '../../components/Button/FooterButtons';
import OrderOnCallButton from '../../components/Button/OrderOnCallButton';
import AddressCard from '../../components/Address/AddressCard';
import AddEditCustomerAddress from '../../components/Address/AddEditCustomerAddress';
import './DeliveryAddress.scss';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../../actions';
import * as Constants from '../../constants';
import PaymentPreferance from '../../components/PaymentPreferance/PaymentPreferance';

const initialState = {
  selectedOption: -1,
  errorMsg: '',
  selectedAddressId: '',
  addnewAddressView: false,
  editAddressDetails: '',
  paymentModeId: '',
  paymentModeSubId: '',
  addressDetails: {
    contactName: '',
    typeDescription: '',
    flatNumber: '',
    streetName: '',
    cityName: '',
    pincode: '',
    contactNumber: '',
  },
  paymentMethodsData: {},
  isLoading: false,
};
class DeliveryAddress extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
    this.props.actions.getAddresses();
    this.props.actions.getCartAmountBifurcation();
  }
  componentWillMount() {
    this.setState(this.props.orderParams);
    this.props.actions.changeHeaderState(Constants.SELECT_ADDRESS);
  }
  componentWillReceiveProps(newProps) {
    const pathname = window.location.pathname;
    const type = newProps.addresses.action && newProps.addresses.action.type;
    const oldType = this.props.addresses.action && this.props.addresses.action.type;
    const globalAction = newProps.action;

    switch (globalAction.type) {
      case Constants.CLOSE_THIS_TASK:
        this.cancelOrder();
        break;
      case Constants.MOVE_FORWARD:
        globalAction.path == pathname && this.checkRxAvailability();
        break;
      case Constants.MOVE_BACKWARD:
        globalAction.path == pathname && this.backToProducts();
        break;
      case Constants.ADD_NEW_ADDRESS:
        globalAction.path == pathname && this.addNewAddressClicked();
        break;
    }
    if (type === oldType) {
      return;
    }
    switch (type) {
      case Constants.ADD_ADDRESS_SUCCESS:
        this.setState({ addnewAddressView: !this.state.addnewAddressView });
        const newAddress = lodashGet(newProps, 'addresses.action.data.data[0]');
        if (newAddress && newAddress.id) {
          this.selectAddress(newAddress);
        } else {
          this.selectAddress(newProps.addresses.data[0]);
        }
        break;
      case Constants.EDIT_ADDRESS_SUCCESS:
        this.setState({ addnewAddressView: !this.state.addnewAddressView });
        break;
      case Constants.FETCH_ADDRESSES_SUCCESS:
        (!this.state.selectedAddressId && newProps.addresses.data.length);
        break;
      default:
      // no-op
    }
  }

  setPaymentMethodsData = data => {
    if (this.props.customer.omsEnabled) {
      this.setState({ paymentMethodsData: data });
    } else {
      this.setState({ paymentMethodsData: data.data });
    }
  }

  componentDidMount() {
    const { orderParams, cart } = this.props;
    this.setState(orderParams);
    if (isEmpty(cart) || !cart.data || cart.data.itemsCount === 0) {
      alert('Cart Empty! Please add products before proceeding.');
      browserHistory.push('/add-products');
    }
  }

  fetchPaymentMethods() {
    this.setState({
      isLoading: true,
    });
    this.props.actions
      .fetchPaymentMethods(this.state.selectedAddressId)
      .then(data => this.setPaymentMethodsData(data))
      .finally(() =>
        this.setState({
          isLoading: false,
          paymentModeId: null,
          selectedOption: -1,
        })
      );
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.cart.data.itemsCount !== this.props.cart.data.itemsCount || prevState.selectedAddressId !== this.state.selectedAddressId) {
      this.fetchPaymentMethods();
    }
  }

  addNewAddressClicked() {
    this.setState({ editAddressDetails: '' });
    this.setState({ addnewAddressView: !this.state.addnewAddressView });
  }
  editAddressClicked(details) {
    this.setState({ editAddressDetails: details });
    this.setState({ addnewAddressView: !this.state.addnewAddressView });
  }
  saveNewAddress(newAddress) {
    if (newAddress.id) {
      this.props.actions.editAddress(newAddress);
    } else {
      this.props.actions.saveNewAddress(newAddress);
    }
  }
  deleteAddress(id) {
    const { selectedAddressId } = this.state;
    if (!confirm('Are you sure you want to delete this address.')) {
      return;
    }
    this.props.actions.deleteAddress(id).then(() => {
      if (selectedAddressId == id) {
        this.setState({ selectedAddressId: '' });
      }
    });
  }
  reset() {
    this.props.actions.setOrderParams(initialState);
    this.setState(initialState);
  }
  backToProducts() {
    this.props.actions.setOrderParams(this.state);
    browserHistory.push({ pathname: '/add-products', state: { alreadyVisitedProductsPage: true } });
  }
  checkRxAvailability() {
    const { cart } = this.props;
    if (isEmpty(cart) || !cart.data || cart.data.itemsCount === 0) {
      alert('Cart Empty! Please add products before proceeding.');
      browserHistory.push('/add-products');
      return;
    }

    if (!this.state.selectedAddressId) {
      alert('Please select address');
      return;
    }
    if (!this.state.paymentModeId) {
      alert('Please select payment mode');
      return;
    }
    this.props.actions.setOrderParams(this.state);
    browserHistory.push('/rx-availability');
  }

  cancelOrder() {
    if (confirm('Are you sure you want to cancel this order ?')) {
      this.reset();
      this.props.actions.cancelOrder();
      browserHistory.push('/customer-info');
    }
  }

  async selectAddress(addressObj) {
    const { id, cityId } = addressObj;
    this.setState({ selectedAddressId: id });
    // Order Type hardcoded 4(ATC) as every order on OOC is placed through cart
    this.setState({ paymentModeId: null, selectedOption: -1 });
    this.props.actions.selectAddress(addressObj);
    this.props.actions.fetchCityDetails(cityId);
    this.setState({ isLoading: true });
    if (this.props.customer.omsEnabled) {
      await this.props.actions.getCartItemsV5({ addressId: id });
    } else {
      await this.props.actions.getCartItems({ addressId: id });
    }
    const { data: { balance: walletBalance = 0 } = {} } = await this.props.actions.fetchWalletDetails();
    this.setState({ walletBalance, isLoading: false });

    this.setState({ isLoading: false });
  }

  handlePaymentModeSelection = ({ payment_type_id, payment_sub_type_id }) => {
    this.setState(
      { paymentModeId: payment_type_id, paymentModeSubId: payment_sub_type_id }
      , async () => {
        await this.props.actions.setOrderParams(this.state);
        if (this.props.customer.omsEnabled) {
          this.props.actions.getCartItemsV5();
        } else {
          this.props.actions.getCartItems();
        }
      }
    );
  };

  handleWalletOptIn = optForWallet => {
    this.setState(
      { optForWallet }
      , async () => {
        await this.props.actions.setOrderParams(this.state);
        if (this.props.customer.omsEnabled) {
          this.props.actions.getCartItemsV5();
        } else {
          this.props.actions.getCartItems();
        }
      }
    );
  }

  render() {
    const {
      activeRefills,
      addresses,
      gateways,
      cart,
      orderParams: {
        optForWallet,
      }
    } = this.props;

    const walletDetails = lodashGet(cart.action, 'data.walletDetails') || {};

    const {
      addnewAddressView,
      addressDetails,
      errorMsg,
      editAddressDetails,
      selectedAddressId,
      selectedOption,
      paymentMethodsData,
      walletBalance,
      isLoading,
      paymentModeId,
      paymentModeSubId,
    } = this.state;
    const enabledRadio = 'https://pe-web-assets.s3.amazonaws.com/images/prescriptions/radio_button_enabled.svg';
    const disabledRadio = 'https://pe-web-assets.s3.amazonaws.com/images/prescriptions/radio_button_disabled.svg';
    const { loading, action } = addresses;
    const showPaymentPreferance = !addnewAddressView && paymentMethodsData && paymentMethodsData.payment_modes;

    return (
      <div ref={div => { this.DeliveryAddressContainer = div; }} className={`DeliveryAddressContainer ${isLoading ? 'pe-loading' : ''}`}>
        <div className="DeliveryAddressHeader">
          <div className="DeliveryAddressHeaderText">{addnewAddressView ? 'Add Delivery Address' : 'Delivery Address'}</div>
          <div className="AddNewAddressBtn">
            <OrderOnCallButton
              tabIndex={1}
              text={addnewAddressView ? 'Back to Saved Addresses' : 'Add New Address'}
              onClickFunction={this.addNewAddressClicked.bind(this)}
            />
          </div>
        </div>
        {!addnewAddressView && <div className="DeliveryAddressesContainer">
          {addresses.data && addresses.data.length > 0 ? addresses.data.map(address =>
            <AddressCard
              key={address.id}
              selectedAddressId={selectedAddressId}
              deleteAddress={this.deleteAddress.bind(this)}
              editAddressClicked={this.editAddressClicked.bind(this)}
              addressDetails={address}
              loading={loading}
              selectAddress={this.selectAddress.bind(this)}
            />) :
            <div>No address found. Add new address</div>}
          {errorMsg && <div className="errorMsg">{errorMsg}</div>}
        </div>}
        {showPaymentPreferance && <PaymentPreferance
          paymentMethodsData={paymentMethodsData}
          walletBalance={walletBalance || 0}
          selectedPaymentMode={`${paymentModeId}-${paymentModeSubId || ''}`}
          walletOpted={optForWallet}
          selectPaymentMode={this.handlePaymentModeSelection}
          optForWalletPayment={this.handleWalletOptIn}
          walletDetails={cart.cartAmountBifurcation.walletDetails}
          isWalletAsDiscountApplicable={cart.cartAmountBifurcation.isWalletAsDiscountApplicable}
        />}
        {addnewAddressView && <AddEditCustomerAddress action={action} loading={loading} addressDetails={editAddressDetails} saveNewAddress={this.saveNewAddress.bind(this)} />}
        {!addnewAddressView && <FooterButtons
          backBtnText="Back to Products"
          backBtnClick={() => this.backToProducts()}
          proceedBtnClick={() => this.checkRxAvailability()}
          proceedBtnText="Check Rx Availability"
          cancelBtnClick={() => this.cancelOrder()}
          cancelBtnText="Cancel Order"
        />}
      </div>
    );
  }
}
export default connect(state => ({
  activeRefills: state.activeRefills,
  orderParams: state.orderParams,
  addresses: state.address,
  cart: state.cart,
  gateways: state.gateways,
  action: state.action,
  customer: state.customer,
}), dispatch => ({
  actions: bindActionCreators(actions, dispatch)
}))(DeliveryAddress);
